export enum ESyncType {
  Appointments = 'appointments',
  AppointmentTypes = 'appointment-types',
  Blocks = 'blocks',
  Facilities = 'facilities',
  Providers = 'providers',
  Referrals = 'referrals',
  Whitespaces = 'whitespaces',
  Recalls = 'recalls',
}
